import * as React from 'react';

import {Button} from 'shells/button/button';

import type {LandingPageFullFragment} from 'nutshell-graphql-types';

import {useTogglePageStatus} from './graphql/hooks';

type Props = {
    page: LandingPageFullFragment;
};

export function SupportTogglePageStatusButton(props: Props) {
    const {togglePageStatus} = useTogglePageStatus();
    const handleClick = () => {
        const newStatus = props.page.status === 'PUBLISHED' ? 'UNDER_REVIEW' : 'PUBLISHED';
        togglePageStatus({pageId: props.page.id, status: newStatus});
    };

    return (
        <Button onClick={handleClick} variant='support' size='big'>
            Support only: {props.page.status === 'PUBLISHED' ? 'Require review' : 'Approve page'}
        </Button>
    );
}
